import { render, staticRenderFns } from "./remoteRailwayBookingBasic.vue?vue&type=template&id=411e66d2&scoped=true&"
import script from "./remoteRailwayBookingBasic.vue?vue&type=script&lang=js&"
export * from "./remoteRailwayBookingBasic.vue?vue&type=script&lang=js&"
import style0 from "./remoteRailwayBookingBasic.vue?vue&type=style&index=0&id=411e66d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411e66d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('411e66d2')) {
      api.createRecord('411e66d2', component.options)
    } else {
      api.reload('411e66d2', component.options)
    }
    module.hot.accept("./remoteRailwayBookingBasic.vue?vue&type=template&id=411e66d2&scoped=true&", function () {
      api.rerender('411e66d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/remoteRailwayBookingBasic.vue"
export default component.exports